import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityOrderTemplateListTemplate } from "themes/application/facility-order/pages";
import { FacilityOrderTemplateListViewStore } from "application/facility-order/stores";

@setCurrentView(rootStore => new FacilityOrderTemplateListViewStore(rootStore), "facilityOrderTemplateListViewStore")
@observer
class FacilityOrderTemplateList extends React.Component {
    render() {
        return <FacilityOrderTemplateListTemplate {...this.props} />;
    }
}

export default FacilityOrderTemplateList;